import { createFileRoute } from '@tanstack/react-router';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { ensureDigitalTwinsQueryData } from '@/features/estate-media/api/get-digital-twins';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/estates/$estateId/_dashboard-layout/media/digital-twins'
)({
  loader: ensureDigitalTwinsQueryData,
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="3D-models" /> },
});
